import {
  commonNextId,
  createShare,
  createVideoShare,
  uploadImageShare,
  uploadVideoShare,
  listDataShare,
  deleteShare,
  uploadVideoOneShare,
  portalShare,
  portalShareKapi,
  createShareKapi,
  createVideoShareKapi,
  deleteShareKapi
} from '@/zsm-api-new/share.js'
const state = {

}

const mutations = {

}

const actions = {

  // id生成
  commonNextId({
	  commit
  }) {
	  return new Promise((resolve, reject) => {
	    commonNextId().then(response => {
	      resolve(response)
	    }).catch(error => {
	      reject(error)
	    })
	  })
  },

  // 知识库==发布视频
  portalShareKapi({ commit }, info) {
    return new Promise((resolve, reject) => {
      portalShareKapi(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 上传视频接口
  portalShare({
	  commit
  }, info) {
	  return new Promise((resolve, reject) => {
	    portalShare(info).then(response => {
	      resolve(response)
	    }).catch(error => {
	      reject(error)
	    })
	  })
  },

  // 获取分享数据
  listDataShare({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      listDataShare(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 知识库==新增分享数据
  createShareKapi({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      createShareKapi(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 新增分享数据
  createShare({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      createShare(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 知识库==发布抖音视频
  createVideoShareKapi({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      createVideoShareKapi(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 发布抖音视频
  createVideoShare({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      createVideoShare(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 上传素材图片
  uploadImageShare({
    commit
  }, info) {
    const {
      filePath,
      frontId
    } = info
    return new Promise((resolve, reject) => {
      uploadImageShare(filePath, frontId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 知识库==删除分享列表和抖音视频
  deleteShareKapi({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      deleteShareKapi(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 删除分享列表和抖音视频
  deleteShare({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      deleteShare(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 上传素材视频(分片处理后)
  uploadVideoOneShare({
    commit
  }, info) {
    const {
      filePath,
      frontId,
      size
    } = info
    return new Promise((resolve, reject) => {
      uploadVideoOneShare(filePath, frontId, size).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 上传素材视频
  uploadVideoShare({
    commit
  }, info) {
    const {
      filePath,
      frontId
    } = info
    return new Promise((resolve, reject) => {
      uploadVideoShare(filePath, frontId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
